import { render, staticRenderFns } from "./serveList.vue?vue&type=template&id=7a59c659&scoped=true"
import script from "./serveList.vue?vue&type=script&lang=js"
export * from "./serveList.vue?vue&type=script&lang=js"
import style0 from "./serveList.vue?vue&type=style&index=0&id=7a59c659&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/registry.npmmirror.com+vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.106.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a59c659",
  null
  
)

export default component.exports